import styled from 'styled-components'

/**
 * Tokens do Figma (Display Campaign Approval → Drawer, node 6106:2514):
 * conteúdo com padding 8/24/40, gap 20px, texto Inter 14px/20px com
 * letter-spacing -0.14px e cor #1f1f1f; nome do publisher em Medium (500).
 */
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 0.5rem 1.5rem 2.5rem;

  /* Largura do drawer no Figma (400px); o painel abre com size="fluid" e
     herda a largura do conteúdo. */
  width: 25rem;
  max-width: 90dvw;

  color: #1f1f1f;
  font-size: 0.875rem;
  line-height: 1.25rem;
  letter-spacing: -0.14px;

  header {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    strong {
      font-weight: 500;
    }
  }

  p {
    margin: 0;
    white-space: pre-line;
  }
`
